export default __webpack_public_path__ + "static/rak-8bdd3e6a681687d4140d54744d486c06.png";